import React, { useEffect, useState, useRef } from 'react';
import { Button, Image, Input, PaperIcon, Popover } from '@nackle/paper';
const { TextArea } = Input;
import Editor from '@nackle/ecard-editor';
import { LocaleString, getString } from '@nackle/intl-tools';
import Picker from 'emoji-picker-react';
import { CSSTransition } from 'react-transition-group';
import { useDispatch, useSelector } from 'react-redux';
import { getEcards, getSelectedProgram } from 'app/app-dux/program-dux';
import { getMessage, getSelectedEcard, setMessage, setSelectedEcard } from 'app/app-dux/message-dux';
import { USER_STORAGE_KEY } from '../../../../constants';
import { ecardUrl } from 'endpoints';
import { Emoticon, XIcon } from '../../shared/icons/icons';

import './message.less';

export function Message( props ) {
    const [ animate, setAnimate ] = useState( false );
	const [ eCardPickerOpen, seteCardPickerOpen ] = useState( true );
	const [ eCardEditorState, seteCardEditorState ] = useState( {} );
	const [ emojiPickerVisible, setEmojiPickerVisible ] = useState( false );
	const [ showEmojis, setShowEmojis ] = useState( false );
	const [ mainCursor, setMainCursor ] = useState();
	const [ messageFocused, setMessageFocused ] = useState( false );

	const messageRef = useRef( null );
	const emojiPickerRef = useRef( null );

	const dispatch = useDispatch();

	const ecards = useSelector( getEcards );
	const selectedProgram = useSelector( getSelectedProgram );
	const message = useSelector( getMessage );
	const selectedEcard = useSelector( getSelectedEcard );

	let user = localStorage.getItem( USER_STORAGE_KEY );
	user = user ? JSON.parse( user ) : {};

	useEffect( () => {
		setAnimate( true );
		window.addEventListener( 'touchstart', handleWindowMouseOrTouch );
		window.addEventListener( 'mousedown', handleWindowMouseOrTouch );
	} );

	useEffect( () => {
		return () => {
			window.removeEventListener( 'touchstart', handleWindowMouseOrTouch );
			window.removeEventListener( 'mousedown', handleWindowMouseOrTouch );
		};
	}, [] );
	
	const handleInputChange = ( event ) => {
		dispatch( setMessage( event.target.value ) );
	};
	const onEcardSave = ( item ) => {
		let { ecardText } = item;
		if ( !ecardText )
		{
			ecardText = '';
		}
		seteCardPickerOpen( false );
		seteCardEditorState( { ...item, ecardText } );
	};
	const editImage = () => {
		dispatch( setSelectedEcard( {} ) );
		seteCardPickerOpen( !eCardPickerOpen );
	};
	const handleSelectedEcard = ( option ) => {
		const emptyOption = Object.keys( option ).length === 0;
		dispatch( setSelectedEcard( option ) );
		//If the option was empty (the user removed the card) clear out the eCardEditorState.
		if ( emptyOption )
		{
			seteCardEditorState( {} );
		}
	};

	const messageFocusToggle = ()=> {
		setMessageFocused( !messageFocused );
	};
	const trackMainCursor = event => {
		const cursor = event.target.selectionStart;

		setMainCursor( cursor  );
	};

	const triggerEmojiPicker = () => {
		setEmojiPickerVisible( !emojiPickerVisible );
		setTimeout( () => { setShowEmojis( true );}, 100 );
	};

	const emojiClick = ( event, emoji ) => {
		// figure out how many cursor positions to move after inserting
		const emojiBits = emoji.unified.split( '-' );
		const bitsCount = emojiBits.length;
		const shiftOver = bitsCount * 2;

		if ( !message ) {
			dispatch( setMessage( `${ emoji.emoji }` ) );
			if ( emoji.unified.length > 5 ) {
				setMainCursor( shiftOver );
			} else {
				setMainCursor( 2 );
			}
		} else if ( mainCursor !== undefined ) {

			const messageFront = message.slice( 0, mainCursor );
			const messageBack = message.slice( mainCursor );
			const updatedMessage = `${ messageFront }${ emoji.emoji }${ messageBack }`;
			dispatch( setMessage( updatedMessage ) );
			if ( emoji.unified.length > 5 ) {
				setMainCursor( mainCursor + shiftOver );
			} else {
				setMainCursor( mainCursor + 2  );
			}
		}
	};

	const handleWindowMouseOrTouch = ( e ) => {
		if ( emojiPickerRef && emojiPickerRef.current ) {
			if ( !emojiPickerRef.current.contains( e.target ) ) {
				setEmojiPickerVisible( false );
				setShowEmojis( false );
			}
		}
	};

	const focusMessage = ( event ) => {
		if ( emojiPickerRef && emojiPickerRef.current ) {
			if ( emojiPickerRef.current.contains( event.target ) ) {
				return;
			}
		}
		messageRef.current.focus();
	};

	const handleKeyPress = ( e, callback, variables ) => {
		if ( e.key === 'Enter' ) {
			if ( typeof callback === 'function' ) {
				if ( variables ) {
					callback( variables );
				} else {
					callback();
				}
			}
		}
	};

	return (
		<CSSTransition
			timeout={ 1000 }
            in={ animate }
            classNames={ props.forward ? 'slide-in' : 'slide-out' }>
				<div className="message-container">
					<LocaleString code="recognition.message.header" TextComponent="h3" className="recognitionLabel"/>
					<div className="message-form">
						<TextArea
							className='message-input'
							ref={ messageRef }
							rows={ 4 }
							autoFocus
							showCount
							placeholder={ getString( 'recognition.message.placeholder' ) }
							aria-label={ getString( 'recognition.recognitionTextInput.label' ) }
							autoSize={ { minRows: 4, maxRows: 8 } }
							onFocus={ messageFocusToggle }
							onBlur={ messageFocusToggle }
							value={ message }
							onChange={ handleInputChange }
							onKeyUp={ trackMainCursor }
							onClick={ trackMainCursor }
							maxLength={ 2000 }
						/>
						<Popover
							overlayClassName="picker-popover"
							trigger="click"
							onClick={ triggerEmojiPicker }
							visible={ emojiPickerVisible }
							content={
								<div ref={ emojiPickerRef } className="emoji-container">
									{
										showEmojis &&
										<Picker
											pickerStyle={ { fontFamily: 'Poppins, apple color emoji, segoe ui emoji, noto color emoji, android emoji, sans-serif' } }
											onEmojiClick={ emojiClick }
											native={ true }
										/>
									}
								</div>
							}
						>
							<div className="emoji-picker-container">
								<Button aria-label={ getString( 'recognition.emojiButton.label' ) } className="emoji-btn" shape="circle" icon={ <Emoticon /> } />
							</div>
						</Popover>
					</div>
					{ ecards && ecards.length > 0 &&
						<div className="ecard-header">
							<h4 className='header-text'>
								<LocaleString code='recognition.message.cardHeader' />
								<span className="header-helper-text">
								<LocaleString code={ selectedProgram?.ecardRequired ? 'recognition.header.required' : 'recognition.header.optional' } />
							</span>
							</h4>
						</div>
					}
					<span onClick={ focusMessage }>
						{ selectedEcard && selectedEcard.images &&
						<div className="ecard-image-selected">
							<Image
								alt=""
								onClick={ editImage }
								src={ `${ ecardUrl }/companies/${ user.claims.company_id }/ecards/${ selectedEcard.id }/locales/${ user.claims.locale }` }
								preview={ false } />
							<PaperIcon icon={ <XIcon fill="#FFFFFF"/> } className="close-icon" originalSize={ true } onClick={ () => handleSelectedEcard( {} ) } />
						</div>
						}
					</span>
					{
						( ecards && ecards.length > 0 && !selectedEcard.images ) &&
						<div className='ecards-container'>
							<Editor
								ecards={ ecards }
								token={ user.access_token }
								setEcardImage={ handleSelectedEcard }
								open={ true }
								directSelect={ true }
								className='ecard-hatch'
								drawerClass='ecard-drawer'
								locale={ user.claims?.locale }
								ecardState={ eCardEditorState }
								onSave={ onEcardSave }
								hideCustomization={ true }
								handleKeyPress={ handleKeyPress }
								companyId={ user.claims?.company_id }
							/>
						</div>
					}
				</div>
		</CSSTransition>
	);
}